import { useLocation, useParams } from 'react-router-dom';
import { useState } from 'react';
import JoinUsPhase1View from './JoinUsPhase1View';
import JoinUsPhase2View from './JoinUsPhase2View';
import JoinUsPhase3View from './JoinUsPhase3View';

const JoinUsView = () => {
    const params = useParams();
    const [phase, setPhase] = useState(params.phase);

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='user-wrap'>
                    <div className='join-top'>
                        <h2 className='join-tit'>회원가입</h2>
                        <div className='join-step-box'>
                            <ul className='join-step-list'>
                                <li className={'join-step-items ' + (phase == '1' ? 'active' : '')}>
                                    <span className='step-num'>1</span>
                                    <span className='step-txt'>개인정보수집동의</span>
                                </li>
                                <li className={'join-step-items ' + (phase == '2' ? 'active' : '')}>
                                    <span className='step-num'>2</span>
                                    <span className='step-txt'>이메일 주소 인증</span>
                                </li>
                                <li className={'join-step-items ' + (phase == '3' ? 'active' : '')}>
                                    <span className='step-num'>3</span>
                                    <span className='step-txt'>사용자 정보 입력</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {phase == '1' ? <JoinUsPhase1View setPhase={setPhase} /> : <></>}
                    {phase == '2' ? <JoinUsPhase2View setPhase={setPhase} /> : <></>}
                    {phase == '3' ? <JoinUsPhase3View setPhase={setPhase} /> : <></>}
                </div>
            </div>
        </section>
    );
};

export default JoinUsView;
